import axios from "axios";
import * as languages from "../configs/languages";

let httpProviderInstance = null;

function createHttpProvider() {
  if (!httpProviderInstance) {
    httpProviderInstance = axios.create({
      baseURL: window.env.ServerUrl,
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": getLanguageLocale(),
        "X-IBM-Client-Id": window.env.IBMClientId,
        "X-IBM-Client-Secret": window.env.IBMClientSecret,
      },
    });
  }
  return httpProviderInstance;
}

// Export a proxy that creates the instance on first access
const httpProvider = new Proxy(
  {},
  {
    get(target, prop) {
      const instance = createHttpProvider();
      const value = instance[prop];
      return typeof value === "function" ? value.bind(instance) : value;
    },
  },
);

export default httpProvider;

function getLanguageLocale() {
  let language = localStorage.getItem("language") || "EN";
  let maybeLocale = languages.Languages.find(
    (edition) => edition.edition == language,
  );
  return maybeLocale
    ? maybeLocale.langaugeLocale
    : languages.DefaultLanguage.edition;
}
